import clsx from 'clsx';
import PropTypes from 'prop-types';
import * as React from 'react';

export const Progress = React.forwardRef(
  (
    {
      className,
      progress = 0,
      bgColor = 'bg-brand-primary-200',
      progressColor = 'bg-brand-primary-500',
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={clsx(className, bgColor, 'w-full rounded-md h-4')}
      >
        <div
          className={clsx(progressColor, 'h-4 rounded-l-md')}
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    );
  }
);

Progress.propTypes = {
  className: PropTypes.string,
  bgColor: PropTypes.string,
  progress: PropTypes.number,
  progressColor: PropTypes.string,
};
